import { IAnalytics } from '../../types/analytics';
import { TReduxActions } from '../../types/redux';
import { prepareProducts } from '../../mappers/prepareProducts';
import { EAnalyticsActionTypes } from '../../actions/analytics';

const defaultState = {
  products: {
    entities: {},
    pages: [],
    extra: {
      actions_info: [],
    },
  },
  offersQty: 0,
};

export function analyticsReducer(state: IAnalytics = defaultState, action: TReduxActions): IAnalytics {
  switch (action.type) {
    case EAnalyticsActionTypes.SetProducts: {
      return {
        products: prepareProducts(action.payload),
        offersQty: action.payload.length,
      };
    }
    default:
      return state;
  }
}
